<template>
    <div class="article-blog-expect">
        <p>
            So you've decided to take the plunge and attend your first class, and perhaps you're wondering how it will
            go down. Read on to find out.
        </p>
        <p>
            First of all, West Coast Swing is a partner dance - that means two people dance together and one of them
            'leads' the dance, while the other 'follows'. So your first task is to decide whether you want to lead or
            follow. The lead signals the moves, and it's up to the follow to respond.
        </p>
        <p>
            Once we've divided the class into leads and follows, and before we find a partner, you're going to learn the
            basic rhythms - this is really just stepping in time to the music!
        </p>
        <p>
            Next we'll each find a partner for the next section. Don't worry, we'll rotate partners throughout the class
            so if doesn't matter if you don't have a partner to start with. Then you're going to learn one of the five
            basic moves of West Coast Swing, and perhaps a starter step. You'll be shown the footwork first and then
            it's time to put it all together with a partner.
        </p>
        <p>
            And that's pretty much it for an introduction class. Attend all classes of Level 1/2 and you will have
            learned the fundamental moves of the dance. But don't worry if you miss a lesson, it will come around again
            and you can catch it next time. Each class is a standalone lesson, so you can drop in and drop out as you
            like.
        </p>
        <p>
            <em
                >Hopefully now you can see that your first class is well within your reach. The classes are structured
                into bitesize bits - it's just a case of taking your first step - so come on down!</em
            >
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleBlogExpect',
};
</script>
